<tec-modal
    [isVisible]="true"
    type="scrollable"
    [title]="'IDENTITIES.DETAIL.EDIT_TITLE' | translate"
    [buttonPrimaryLabel]="'BUTTON.SAVE' | translate"
    [buttonPrimaryLabelLoading]="'BUTTON.SAVING' | translate"
    [buttonPrimaryLoading]="saving"
    [buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
    (closeEvent)="closeModal($event)"
>
    <ng-container body>
        @if (errorMsg) {
            <tec-alert status="error" [msg]="errorMsg" (closeAlert)="errorMsg = ''" />
        }
        <div class="layout__column" [formGroup]="form">
            <tec-tile>
                {{ ('PROCESSES.REVIEW.DOCUMENT' | translate).toUpperCase() }}
                <div class="grid grid-i2">
                    <tec-form-group
                        [label]="'PROCESSES.REVIEW.FORM.IDENTIFIER' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('identifier'))"
                    >
                        <tec-input
                            formControlName="identifier"
                            [hasError]="reactiveFormService.hasError(form.get('identifier'))"
                        ></tec-input>
                    </tec-form-group>
                    <tec-info-group [label]="'PROCESSES.REVIEW.FORM.DOCUMENT_TYPE' | translate">
                        <span class="document-type-value">
                            {{ documentTypeLabel || ('GENERAL.NOT_AVAILABLE' | translate) }}
                        </span>
                    </tec-info-group>
                    <tec-form-group
                        [label]="'PROCESSES.REVIEW.FORM.NACIONALITY' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('nationality'))"
                    >
                        <tec-select
                            formControlName="nationality"
                            [options]="allCountries"
                            [hasError]="reactiveFormService.hasError(form.get('nationality'))"
                        ></tec-select>
                    </tec-form-group>
                    <tec-form-group
                        [label]="'PROCESSES.REVIEW.FORM.EXPIRATION_DATE' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('expiration_date'))"
                    >
                        <div class="expiration-date-field">
                            <tec-datepicker
                                formControlName="expiration_date"
                                [hasError]="reactiveFormService.hasError(form.get('expiration_date'))"
                            ></tec-datepicker>
                            <tec-checkbox
                                formControlName="expiration_permanent"
                                [label]="'PROCESSES.REVIEW.FORM.PERMANENT' | translate"
                            ></tec-checkbox>
                        </div>
                    </tec-form-group>
                </div>
                <tec-divider></tec-divider>
                {{ ('PROCESSES.REVIEW.IDENTITY' | translate).toUpperCase() }}
                <div class="grid grid-i2">
                    <tec-form-group
                        [label]="'PROCESSES.REVIEW.FORM.BIRTHDATE' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('birthdate'))"
                    >
                        <tec-datepicker
                            formControlName="birthdate"
                            [maxDate]="birthdateMaxDate"
                            [hasError]="reactiveFormService.hasError(form.get('birthdate'))"
                        ></tec-datepicker>
                    </tec-form-group>
                    <tec-form-group
                        [label]="'PROCESSES.REVIEW.FORM.GENDER' | translate"
                        [errorMsg]="reactiveFormService.hasMsgError(form.get('gender'))"
                    >
                        <tec-select
                            formControlName="gender"
                            [options]="[
                                { id: 'M', label: 'MASTER.GENDERS.M' | translate },
                                { id: 'F', label: 'MASTER.GENDERS.F' | translate }
                            ]"
                            [hasError]="reactiveFormService.hasError(form.get('gender'))"
                        ></tec-select>
                    </tec-form-group>
                </div>
                <tec-form-group
                    [label]="'PROCESSES.REVIEW.FORM.NAME' | translate"
                    [errorMsg]="reactiveFormService.hasMsgError(form.get('names'))"
                >
                    <tec-input
                        formControlName="names"
                        [hasError]="reactiveFormService.hasError(form.get('names'))"
                    ></tec-input>
                </tec-form-group>
                <tec-form-group
                    [label]="'PROCESSES.REVIEW.FORM.SURNAMES' | translate"
                    [errorMsg]="reactiveFormService.hasMsgError(form.get('surnames'))"
                >
                    <tec-input
                        formControlName="surnames"
                        [hasError]="reactiveFormService.hasError(form.get('surnames'))"
                    ></tec-input>
                </tec-form-group>
            </tec-tile>
        </div>
    </ng-container>
</tec-modal>
